var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({ref:"imgEl",attrs:{"src":_vm.imgUrl,"data-slug":_vm.slug},on:{"load":_vm.on_load}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }